import { ConcreteExperienceMessage } from '@dadohr/shared/domainTypes/experience';
import {
  ScheduleChannel,
  ScheduleChannelType
} from '@dadohr/shared/domainTypes/schedules';

/** The template channels a failed concrete message was sent on. */
export const getChannelsForSentItem = (
  tplChannels: ScheduleChannel[],
  msg: ConcreteExperienceMessage
): ScheduleChannel[] => {
  return tplChannels.filter((c) => {
    if (msg.provider === 'SLACK') {
      return c.type === ScheduleChannelType.SLACK;
    }
    if (msg.provider === 'TEAMS') {
      return c.type === ScheduleChannelType.MS_TEAMS;
    }
    if (msg.provider === 'TWILIO') {
      return c.type === ScheduleChannelType.SMS;
    }
    if (msg.provider === 'POSTMARK_EMAIL') {
      return (
        c.type === ScheduleChannelType.EMAIL && c.emailFrom === msg.emailFrom
      );
    }
    return false;
  });
};
